module.exports = __webpack_public_path__ + "assets/0f779725fc44522b3c411fd3247c804b.json";